import { render, staticRenderFns } from "./AuthStart.vue?vue&type=template&id=7c029f2a&scoped=true"
import script from "./AuthStart.vue?vue&type=script&lang=ts"
export * from "./AuthStart.vue?vue&type=script&lang=ts"
import style0 from "./AuthStart.vue?vue&type=style&index=0&id=7c029f2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c029f2a",
  null
  
)

export default component.exports